"use client";

import { c as _c } from "react/compiler-runtime";
import { NewsBlogCategorySection } from "@/views/home/variants/NewsBlogHomepage/Classic/components/NewsBlogCategorySection";
import type { NewsBlogCategorySectionData } from "@/views/home/variants/NewsBlogHomepage/Classic/types";
export type { NewsBlogCategorySectionData as CategorySectionData };
export interface CategorySectionProps {
  data: NewsBlogCategorySectionData;
  /** Lead image is the page's LCP candidate. Only the first hero on a page. */
  priority?: boolean;
}

/**
 * CategorySection — Renders a single category-driven content section suitable for
 * placement in a homepage mixed content stream.
 *
 * Layout: lead article hero (2/3 width) + secondary hero + mini headline stack (1/3 width).
 * Shows up to 6 articles (1 lead + 1 secondary + up to 4 minis).
 *
 * This is a thin re-export of {@link NewsBlogCategorySection} under the shared `parts/`
 * contract so that non-news-blog variants (e.g. BasicHomepage) can consume it without
 * importing from the NewsBlogHomepage tree.
 */
export function CategorySection(t0) {
  const $ = _c(3);
  const {
    data,
    priority: t1
  } = t0;
  const priority = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== data || $[1] !== priority) {
    t2 = <NewsBlogCategorySection data={data} priority={priority} />;
    $[0] = data;
    $[1] = priority;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}